export const PlaceholderBox = () => {
  return <div className="h-full w-full animate-pulse rounded-28 bg-black-25 bg-opacity-30"></div>;
};
